import { render, staticRenderFns } from "./StylesInWatch.vue?vue&type=template&id=0a9c5e6d&scoped=true"
import script from "./StylesInWatch.vue?vue&type=script&lang=js"
export * from "./StylesInWatch.vue?vue&type=script&lang=js"
import style0 from "./StylesInWatch.vue?vue&type=style&index=0&id=0a9c5e6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c5e6d",
  null
  
)

export default component.exports